import i18next from '@app/i18n';

export const i18nCustom = (translationContextKey) => {
  //TODO: load other language here
  const lang = localStorage.getItem('lang') || 'ru';
  const translate = (() => i18next.t(`${lang}.${translationContextKey}`))();

  return translate;
};
